export default function initVibeModal() {
   const modal = document.querySelector('.js-vibe-modal');
   const closeBtn = document.querySelector('.js-vibe-modal-close');

   if (!modal) return;

   let timeoutId;

   // Constantes de tiempo
   const FIRST_APPEARANCE_MS = 120000; // 2 minutos
   const REPEAT_INTERVAL_MS = 300000;  // 5 minutos

   const scheduleModal = () => {
      const lastClosedTime = sessionStorage.getItem('cdr_vibe_last_closed');
      const now = Date.now();

      if (!lastClosedTime) {
         // Es la primera vez de la sesión, mostramos a los 2 minutos
         timeoutId = setTimeout(() => {
            modal.classList.add('active');
         }, FIRST_APPEARANCE_MS);
      } else {
         // Ya se ha mostrado y cerrado, calculamos cuánto falta de los 5 minutos
         const timeElapsed = now - parseInt(lastClosedTime, 10);
         let timeRemaining = REPEAT_INTERVAL_MS - timeElapsed;

         if (timeRemaining <= 0) {
            // Si ya pasaron los 5 mins y recién entra a la vista, mostrar pronto
            timeRemaining = 2000;
         }

         timeoutId = setTimeout(() => {
            modal.classList.add('active');
         }, timeRemaining);
      }
   };

   // Close logic
   const closeModal = () => {
      modal.classList.remove('active');
      sessionStorage.setItem('cdr_vibe_last_closed', Date.now().toString());

      // Limpiamos timeouts anteriores por si acaso y volvemos a programar 5 minutosechedule
      clearTimeout(timeoutId);
      scheduleModal();
   };

   if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
   }

   // Close on overlay click
   modal.addEventListener('click', (e) => {
      if (e.target === modal) {
         closeModal();
      }
   });

   // Close on Escape key
   document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
         closeModal();
      }
   });

   // Start checking when init runs
   scheduleModal();
}
